/**
 * Widget APP entry (ARCHITECTURE §7, build #2).
 *
 * Mounts the React widget into the iframe document served by `index.html`. This
 * is the app the loader's iframe points at with `?cid=ORG_ID-WIDGET_ID`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { WidgetApp } from './WidgetApp';
import './styles/widget.css';

const el = document.getElementById('lc-widget-root');
if (!el) {
  throw new Error('[lc-widget] missing #lc-widget-root mount element');
}

createRoot(el).render(
  <StrictMode>
    <WidgetApp />
  </StrictMode>,
);
